import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-book-meeting-close",
  "use": "icon-book-meeting-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-book-meeting-close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.286 11.771a.667.667 0 1 0 .943.943L8 8.943l3.771 3.771a.667.667 0 0 0 .943-.943L8.943 8l3.771-3.771a.667.667 0 1 0-.943-.943L8 7.057 4.229 3.286a.667.667 0 1 0-.943.943L7.057 8l-3.771 3.771Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol